import { motion } from 'framer-motion';
import QuivverBanner from '../organisms/ProjectsList/QuivverProject/QuivverBanner'
import QuivverProjectOverview from '../organisms/ProjectsList/QuivverProject/QuivverProjectOverview'
import QuivverObjective from '../organisms/ProjectsList/QuivverProject/QuivverObjective'
import QuivverSolutions from '../organisms/ProjectsList/QuivverProject/QuivverSolutions'
import QuivverDream from '../organisms/ProjectsList/QuivverProject/QuivverDream'
import QuivverDetails from '../organisms/ProjectsList/QuivverProject/QuivverDetails'
import AppsTestimonials from '../molecules/AppsTestimonials/AppsTestimonials'
import CompanyLogoImage from '../molecules/CompanyLogoImage/CompanyLogoImage'
import ContactHelp from '../molecules/ContactHelp/ContactHelp'
import Footer from '../organisms/Footer/Footer';
import { getPageData, useData } from '../../app/helper/functions';


const QuivverPage = () => {
    const { data } = useData();
    const quivverProject = getPageData(data, 'quivverProjectPage');
    return (
        <div className='bg-[#0F0D16] overflow-x-hidden relative'>
            <QuivverBanner />
            <div>
                <QuivverProjectOverview />
                <QuivverObjective />
                <QuivverSolutions quivverProject={quivverProject} />
                <QuivverDream />
                <QuivverDetails quivverProject={quivverProject} />
            </div>
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <AppsTestimonials color="#2DEE9A" bgcolor={"bg-[#2DEE9A]"} textColor='black' activeTextColor='white' />
            </motion.div>

            <motion.div
                className='p-4 sm:p-6 md:p-10 px-4 sm:px-16 md:px-36'
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <CompanyLogoImage bgColor='bg-[#222222]' borderColor='border-[#2A2A2A]' />
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true, amount: 0.3 }}
                className="px-4 sm:px-0"
            >
                <ContactHelp title="Let's connect & achieve your business goals together" buttonTitle='CONTACT US' />
            </motion.div>
            <Footer />

        </div>

    )
}

export default QuivverPage;


